<div class="chat-export-container" [testId]="'chat-export-container'">
  <!-- 头部信息 -->
  <header class="chat-export-header" [testId]="'chat-export-header'">
    <div class="header-left">
      <h1 class="page-title">{{ 'servicenumber.chat-export.page-title' | i18n }}</h1>
      <p class="page-desc muted">{{ 'servicenumber.chat-export.page-desc' | i18n }}</p>
    </div>
    <div class="header-right">
      <span class="role-badge" [testId]="'chat-export-role-badge'">
        {{ (config.canManage ? 'servicenumber.chat-export.role-manager' : 'servicenumber.chat-export.role-member') | i18n }}
      </span>
    </div>
  </header>

  <!-- 二级导航 Tabs -->
  <nav class="chat-export-tabs" [testId]="'chat-export-tabs'">
    <button class="tab-btn" [class.active]="activeTab === 'new'" (click)="setActiveTab('new')" [testId]="'chat-export-tab-new'">
      {{ 'servicenumber.chat-export.tab-create' | i18n }}
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'records'" (click)="setActiveTab('records')" [testId]="'chat-export-tab-records'">
      {{ 'servicenumber.chat-export.tab-records' | i18n }}
    </button>
  </nav>

  <!-- 建立汇出视图 -->
  <section *ngIf="activeTab === 'new'" [testId]="'chat-export-view-new'">
    <servicenumber-chat-export-form
      [serviceNumberId]="serviceNumberId"
      [timeZone]="config.timeZone"
      [maxMonth]="config.maxMonth"
      [canManage]="config.canManage"
      [records]="records"
      [submitting]="submitting"
      (submitExport)="handleSubmitExport($event)"
      (viewRecords)="setActiveTab('records')"
      (previewStyle)="handlePreviewStyle()"
      [testId]="'chat-export-form-component'"
    />
  </section>

  <!-- 汇出记录视图 -->
  <section *ngIf="activeTab === 'records'" [testId]="'chat-export-view-records'">
    <servicenumber-chat-export-list
      [records]="records"
      [loading]="loading"
      (download)="handleDownload($event)"
      (detail)="handleDetail($event)"
      (delete)="handleDelete($event)"
      (refresh)="fetchRecords(true)"
      [testId]="'chat-export-list-component'"
    />
  </section>

  <!-- 详情弹窗 -->
  <servicenumber-chat-export-detail-modal
    [visible]="detailModalVisible"
    [task]="selectedDetailTask"
    (visibleChange)="closeDetailModal()"
    [testId]="'chat-export-detail-modal-component'"
  />

  <!-- 樣式預覽彈窗 -->
  <nz-modal
    [nzVisible]="previewModalVisible"
    [nzTitle]="previewTitle"
    [nzFooter]="previewFooter"
    (nzOnCancel)="closePreviewModal()"
    nzWidth="820px"
    [nzBodyStyle]="{ height: '520px', 'max-height': '72vh', 'overflow-y': 'auto' }"
    [testId]="'chat-export-preview-modal'"
  >
    <ng-template #previewTitle>
      {{ 'servicenumber.chat-export.preview-title' | i18n }}
    </ng-template>

    <ng-container *nzModalContent>
      <!-- 顶部提示横幅 -->
      <div class="preview-hint-box" [testId]="'chat-export-preview-hint-box'">
        {{ 'servicenumber.chat-export.preview.top-banner' | i18n }}
      </div>

      <!-- 分段 1: 林小姐 -->
      <div class="preview-room-header" [testId]="'chat-export-preview-room-1-header'">
        <span class="room-name">{{ 'servicenumber.chat-export.preview.customer-ms-lin' | i18n }}</span>
        <span class="room-tag">R-018 · LINE</span>
      </div>
      <div class="preview-table-wrapper" [testId]="'chat-export-preview-table-1-wrapper'">
        <table class="preview-table" [testId]="'chat-export-preview-table-1'">
          <thead>
            <tr>
              <th style="width: 14%">{{ 'servicenumber.chat-export.preview.th-user' | i18n }}</th>
              <th style="width: 16%">{{ 'servicenumber.chat-export.preview.th-date' | i18n }}</th>
              <th>{{ 'servicenumber.chat-export.preview.th-content' | i18n }}</th>
              <th style="width: 26%">{{ 'servicenumber.chat-export.preview.th-time' | i18n }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.system' | i18n }}</td>
              <td>2026-09-03</td>
              <td>{{ 'servicenumber.chat-export.preview.start-chat' | i18n }}</td>
              <td>2026-09-03 09:12:03 +08:00</td>
            </tr>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.customer-ms-lin' | i18n }}</td>
              <td>2026-09-03</td>
              <td>{{ 'servicenumber.chat-export.preview.ask-service' | i18n }}</td>
              <td>2026-09-03 09:12:04 +08:00</td>
            </tr>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.agent-amy' | i18n }}</td>
              <td>2026-09-03</td>
              <td>{{ 'servicenumber.chat-export.preview.reply-service' | i18n }}</td>
              <td>2026-09-03 09:13:20 +08:00</td>
            </tr>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.system' | i18n }}</td>
              <td>2026-09-03</td>
              <td>{{ 'servicenumber.chat-export.preview.end-chat' | i18n }}</td>
              <td>2026-09-03 09:15:00 +08:00</td>
            </tr>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.system' | i18n }}</td>
              <td>2026-09-19</td>
              <td>{{ 'servicenumber.chat-export.preview.start-chat' | i18n }}</td>
              <td>2026-09-19 18:20:00 +08:00</td>
            </tr>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.customer-ms-lin' | i18n }}</td>
              <td>2026-09-19</td>
              <td>{{ 'servicenumber.chat-export.preview.book-again' | i18n }}</td>
              <td>2026-09-19 18:20:02 +08:00</td>
            </tr>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.agent-amy' | i18n }}</td>
              <td>2026-09-19</td>
              <td>{{ 'servicenumber.chat-export.preview.recalled-msg' | i18n }}</td>
              <td>2026-09-19 18:30:12 +08:00</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分段 2: 陈先生 -->
      <div class="preview-room-header" style="margin-top: 24px" [testId]="'chat-export-preview-room-2-header'">
        <span class="room-name">{{ 'servicenumber.chat-export.preview.customer-mr-chen' | i18n }}</span>
        <span class="room-tag">R-027 · WebChat</span>
      </div>
      <div class="preview-table-wrapper" [testId]="'chat-export-preview-table-2-wrapper'">
        <table class="preview-table" [testId]="'chat-export-preview-table-2'">
          <thead>
            <tr>
              <th style="width: 14%">{{ 'servicenumber.chat-export.preview.th-user' | i18n }}</th>
              <th style="width: 16%">{{ 'servicenumber.chat-export.preview.th-date' | i18n }}</th>
              <th>{{ 'servicenumber.chat-export.preview.th-content' | i18n }}</th>
              <th style="width: 26%">{{ 'servicenumber.chat-export.preview.th-time' | i18n }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ 'servicenumber.chat-export.preview.customer-mr-chen' | i18n }}</td>
              <td>2026-09-18</td>
              <td>{{ 'servicenumber.chat-export.preview.file-sample' | i18n }}</td>
              <td>2026-09-18 14:02:10 +08:00</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #previewFooter>
      <button nz-button nzType="default" (click)="closePreviewModal()" [testId]="'chat-export-preview-close-btn'">
        {{ 'common.close' | i18n }}
      </button>
    </ng-template>
  </nz-modal>
</div>
